'use client';
import type { FC } from 'react';
import { defineMessage, useIntl } from 'react-intl';

export interface BrokenSuitcaseProps {
  size?: 'fixed' | 'responsive';
}

const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? '';

export const BrokenSuitcase: FC<BrokenSuitcaseProps> = ({ size = 'fixed' }) => {
  const { formatMessage } = useIntl();
  const imageSrc = `${basePath}/assets/broken-suitcase.png`;
  const isFixedSize = size === 'fixed';

  // Returning an img rather than NextJS's Image component is intentional
  // This allows users to see the image without being authenticated
  return (
    <img
      src={imageSrc}
      alt={formatMessage(altText)}
      width={isFixedSize ? 164 : '100%'}
      height={isFixedSize ? 178 : 'auto'}
    />
  );
};

const altText = defineMessage({
  id: 'shared-ui.broken-suitcase.alt-text',
  defaultMessage: 'Suitcase with broken wheel',
});
